// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * MessageAction : represents various actions in the messages over the connection
 */
export var MessageAction;
(function (MessageAction) {
    MessageAction["MESSAGE_ACTION_UNSPECIFIED"] = "MESSAGE_ACTION_UNSPECIFIED";
    MessageAction["MESSAGE_ACTION_PING"] = "MESSAGE_ACTION_PING";
    MessageAction["MESSAGE_ACTION_PONG"] = "MESSAGE_ACTION_PONG";
    MessageAction["MESSAGE_ACTION_CLOSE"] = "MESSAGE_ACTION_CLOSE";
    MessageAction["MESSAGE_ACTION_SUBSCRIBE"] = "MESSAGE_ACTION_SUBSCRIBE";
    MessageAction["MESSAGE_ACTION_UNSUBSCRIBE"] = "MESSAGE_ACTION_UNSUBSCRIBE";
    MessageAction["MESSAGE_ACTION_NOTIFICATION"] = "MESSAGE_ACTION_NOTIFICATION";
})(MessageAction || (MessageAction = {}));
export var MessageAction_index;
(function (MessageAction_index) {
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_UNSPECIFIED"] = 0] = "MESSAGE_ACTION_UNSPECIFIED";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_PING"] = 1] = "MESSAGE_ACTION_PING";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_PONG"] = 2] = "MESSAGE_ACTION_PONG";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_CLOSE"] = 3] = "MESSAGE_ACTION_CLOSE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_SUBSCRIBE"] = 4] = "MESSAGE_ACTION_SUBSCRIBE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_UNSUBSCRIBE"] = 5] = "MESSAGE_ACTION_UNSUBSCRIBE";
    MessageAction_index[MessageAction_index["MESSAGE_ACTION_NOTIFICATION"] = 6] = "MESSAGE_ACTION_NOTIFICATION";
})(MessageAction_index || (MessageAction_index = {}));
/**
 * SubUnsubEntity: various entities by which we can subscribe/ unsubscribe for updates
 */
export var SubUnsubEntity;
(function (SubUnsubEntity) {
    SubUnsubEntity["SUBUNSUB_ENTITY_UNSPECIFIED"] = "SUBUNSUB_ENTITY_UNSPECIFIED";
    SubUnsubEntity["SUBUNSUB_ENTITY_LOCATION_IDS"] = "SUBUNSUB_ENTITY_LOCATION_IDS";
    SubUnsubEntity["SUBUNSUB_ENTITY_USER_IDS"] = "SUBUNSUB_ENTITY_USER_IDS";
    SubUnsubEntity["SUBUNSUB_ENTITY_ORG_IDS"] = "SUBUNSUB_ENTITY_ORG_IDS";
})(SubUnsubEntity || (SubUnsubEntity = {}));
export var SubUnsubEntity_index;
(function (SubUnsubEntity_index) {
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_UNSPECIFIED"] = 0] = "SUBUNSUB_ENTITY_UNSPECIFIED";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_LOCATION_IDS"] = 1] = "SUBUNSUB_ENTITY_LOCATION_IDS";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_USER_IDS"] = 2] = "SUBUNSUB_ENTITY_USER_IDS";
    SubUnsubEntity_index[SubUnsubEntity_index["SUBUNSUB_ENTITY_ORG_IDS"] = 3] = "SUBUNSUB_ENTITY_ORG_IDS";
})(SubUnsubEntity_index || (SubUnsubEntity_index = {}));
export var Criteria_Type;
(function (Criteria_Type) {
    Criteria_Type["UNKNOWN"] = "UNKNOWN";
    Criteria_Type["LOCATION_ID"] = "LOCATION_ID";
    Criteria_Type["ORG_ID"] = "ORG_ID";
})(Criteria_Type || (Criteria_Type = {}));
export var Criteria_Type_index;
(function (Criteria_Type_index) {
    Criteria_Type_index[Criteria_Type_index["UNKNOWN"] = 0] = "UNKNOWN";
    Criteria_Type_index[Criteria_Type_index["LOCATION_ID"] = 1] = "LOCATION_ID";
    Criteria_Type_index[Criteria_Type_index["ORG_ID"] = 2] = "ORG_ID";
})(Criteria_Type_index || (Criteria_Type_index = {}));
export var Criteria_Condition;
(function (Criteria_Condition) {
    Criteria_Condition["MATCH_ANY"] = "MATCH_ANY";
    Criteria_Condition["MATCH_ALL"] = "MATCH_ALL";
})(Criteria_Condition || (Criteria_Condition = {}));
export var Criteria_Condition_index;
(function (Criteria_Condition_index) {
    Criteria_Condition_index[Criteria_Condition_index["MATCH_ANY"] = 0] = "MATCH_ANY";
    Criteria_Condition_index[Criteria_Condition_index["MATCH_ALL"] = 1] = "MATCH_ALL";
})(Criteria_Condition_index || (Criteria_Condition_index = {}));
export const WebSocketDirector = {};
